/************************* 变量文件 *************************/
const ip = ''

/************************* 测试环境 ***********************/

// const baseUrl = ip + '/api'

/************************* 正式环境 ***********************/

const baseUrl = ip + 'https://qdrs.minmeng.info/ccid'

/********************* 图片上传管理 ***********************/
const upload = ip + '/upload/'
const myValidator = {
	regExpPhone: /^1([345789])[0-9]\d{8}$/,
	regExpEmail: /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/,
	regExpPassword: /.{6,20}$/
}
module.exports = {
	ip,
	baseUrl,
	upload,
	myValidator
}
